export default __webpack_public_path__ + "static/media/twitter-footer.92d8937d.svg";